module.exports = __webpack_public_path__ + "img/d3-min.5e334605.png";